
export { HorizontalProductCardSkeleton } from "/codebuild/output/src1412605272/src/packages/shared-components/src/components/ProductCard/index.ts"
export { VerticalProductCardSkeleton } from "/codebuild/output/src1412605272/src/packages/shared-components/src/components/ProductCard/index.ts"